/* eslint-disable react/forbid-prop-types */
import React, {Component} from 'react';
import PropTypes from 'prop-types';

class KnowledgeCenterFilters extends Component {

    static propTypes = {
        textFilter: PropTypes.string,
        keywords: PropTypes.array,
        keywordsSelected: PropTypes.array,
        handleChange: PropTypes.func,
        handleChangeOnClick: PropTypes.func,
        clearAll: PropTypes.func,
        displayClearAll: PropTypes.bool,
        toggleKeyword: PropTypes.func,
        textFilterType: PropTypes.string,
    };

    static defaultProps = {
        textFilter: '',
        keywords: [],
        keywordsSelected: [],
        handleChange: () => {},
        handleChangeOnClick: () => {},
        toggleKeyword: () => {},
        textFilterType: 'input',
        displayClearAll: false,
        clearAll: () => {},
    };

    static getFilteredKeywords = (keywords) => {
        const allowed = [
            'emerging markets',
            'open trading',
            'regulation',
            'asia',
            'europe',
            'market data',
            'automation',
            'composite+'
        ];

        return keywords.filter(keyword => allowed.includes(keyword.trim().toLowerCase()));
    };

    state = {
        keywordsSelected: [],
        isOptionsOpen: false,
    };

    componentDidMount() {
        document.addEventListener("keydown", this.escFunction.bind(this), false);
    }

    componentWillReceiveProps({keywordsSelected}) {
        this.setState({...this.state, keywordsSelected});
    }

    componentDidUpdate() {
        const { isOptionsOpen } = this.state;
        const menus = document.getElementsByClassName('sideBar__filterDropdown');

        if (isOptionsOpen) {
            window.addEventListener('click', (e) => {
                if (menus && menus.length && menus[0] && !menus[0].contains(e.target) && !menus[0].parentNode.contains(e.target)) {
                    this.close();
                }
            })
        }
        else {
            window.removeEventListener('click', (e) => {
                if (menus && menus.length && menus[0] && !menus[0].contains(e.target) && !menus[0].parentNode.contains(e.target)) {
                    this.close();
                }
            })
        }
        
    }

    componentWillUnmount() {
        // check if the event is bound
        if (this.escFunction.bind(this)) {
            document.removeEventListener("keydown", this.escFunction.bind(this), false);
        }
        
    }

    getKeywordTitle = keyword => {
        if (keyword === 'REGULATION') {
            return 'Regulation';
        }

        return keyword;
    };

    close = () => {
        this.setState({ isOptionsOpen: false, });
    }

    clearAll = () => {
        const {clearAll} = this.props;
        this.setState({keywordsSelected: [], textFilter: ''});
        clearAll();
        this.close();
    };

    handleKeywordSelect = (e, keyword) => {
        const keywordsSelected = this.props.keywordsSelected;
        if (!keywordsSelected.includes(keyword)) {
            keywordsSelected.push(keyword);
        }
        this.setState({keywordsSelected});

        this.props.toggleKeyword(e, keyword);
    };

    toggleOptions = () => {
        this.setState({ isOptionsOpen: !this.state.isOptionsOpen });
    };

    escFunction(e) {
        if (e.key === "Escape") {
            this.setState({ isOptionsOpen: false });
        }
    }

    render() {
        const { textFilter, textFilterType, handleChange, handleChangeOnClick, displayClearAll} = this.props;

        const keywords = KnowledgeCenterFilters.getFilteredKeywords(this.props.keywords);

        return (
            <aside className="knowledgeCenter__sideBar">

                <div className="knowledgeCenter__sideBarInner">

                    {keywords && keywords.length ? (
                        <div className="sideBar__filter sideBar__filterDropdown">
                            <button
                                type="button"
                                aria-haspopup="true"
                                aria-expanded={this.state.isOptionsOpen}
                                className={`sideBar__filterTarget ${this.state.isOptionsOpen ? "expanded" : ""}`}
                                onClick={(e) => {
                                    e.preventDefault();
                                    this.toggleOptions();
                                }}
                            >
                                {!this.state.isOptionsOpen ? <span className="sideBar__filterTargetOpen">Select Topic(s) <span className="fal fa-angle-down" /></span> : <span className="sideBar__filterTargetClose">Close Topics <span className="fal fa-times" /></span>}
                            </button>
                            <ul className={`sideBar__filterList ${this.state.isOptionsOpen ? "show" : ""}`}
                                aria-expanded={this.state.isOptionsOpen}
                            >
                                
                                {keywords.filter(keyword => keyword).map(keyword => (
                                    <li key={`keyword_${keyword}`}>
                                        <input  id={`filter-${keyword}`} 
                                            type="checkbox"
                                            onChange={(e) => {
                                                this.handleKeywordSelect(e, keyword)
                                            }} 
                                            checked={this.state.keywordsSelected.includes(keyword)} />
                                        <label htmlFor={`filter-${keyword}`}>{this.getKeywordTitle(keyword)} <span className="fal fa-times" /></label>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ) : null}

                    {textFilterType === 'input' && (
                        <div className="sideBar__search sideBar__search--onInput">
                            <input placeholder="Search" type="text" value={textFilter} onChange={e => handleChange(e, 'textFilter')}/>
                        </div>
                    )}

                    {textFilterType === 'button' && (
                        <div className="sideBar__search sideBar__search--onSubmit">
                            <form onSubmit={(e) => {
                                e.preventDefault();
                                handleChangeOnClick(textFilter)
                            }}>
                                <input placeholder="Search by Title" type="text" value={textFilter} onChange={e => handleChange(e, 'textFilter')}/> <button type="submit" className="far fa-search"/>
                            </form>
                        </div>
                    )}

                    <div className="sidebar__clearAll">
                        {keywords && keywords.length ? (
                            <div className="sideBar__filter sideBar__filterTopicDisplay">
                                <ul>

                                    {keywords.filter(keyword => keyword).map(keyword => (
                                        <li key={`keyword_${keyword}`} className={this.state.keywordsSelected.includes(keyword) ? 'show' : 'hide'}>
                                            <input id={`filter-${keyword}`}
                                                type="checkbox"
                                                onChange={(e) => {
                                                    this.handleKeywordSelect(e, keyword)
                                                }}
                                                checked={this.state.keywordsSelected.includes(keyword)} />
                                            <label htmlFor={`filter-${keyword}`}>{this.getKeywordTitle(keyword)} <span className="fal fa-times" /></label>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ) : null}

                        {displayClearAll ? (
                            <div className="sideBar__clear">
                                <button onClick={() => this.clearAll()} className="text-cta">Clear All</button>
                            </div>
                        ) : null}
                    </div>

                </div>

            </aside>
        );
    }
}

export default KnowledgeCenterFilters;



// WEBPACK FOOTER //
// ./frontend/components/KnowledgeCenter/KnowledgeCenterFilters.jsx